import React, {useEffect, useState} from "react";
import {DataGrid, GridToolbar} from "@mui/x-data-grid";
import axios from "axios";
import Swal from "sweetalert2";
import {baseUrl} from "../Univ.js";
import {useNavigate} from "react-router-dom";
import "./IoTStyles.css";
function IoTGateways() {
    const navigate = useNavigate();
    const [rows, setRows] = useState([]);
    const [loading, setLoading] = useState(false);
    // ============================================================
    // FETCH GATEWAYS
    // ============================================================
    const fetchGateways = async () => {
        try {
            setLoading(true);
            const response = await axios.get(baseUrl + "iot-gateways/");
            /*
             * DRF pagination support
             */
            if (Array.isArray(response.data)) {
                setRows(response.data);
            } else if (response.data && Array.isArray(response.data.results)) {
                setRows(response.data.results);
            } else {
                setRows([]);
            }
        } catch (error) {
            console.log("IoT Gateway Error:", error);
            Swal.fire("Error", "Unable to load agricultural IoT gateways.", "error");
        } finally {
            setLoading(false);
        }
    };
    // ============================================================
    // INITIAL LOAD
    // ============================================================
    useEffect(() => {
        fetchGateways();
    }, []);
    // ============================================================
    // DELETE GATEWAY
    // ============================================================
    const deleteGateway = async (id) => {
        const result = await Swal.fire({
            title: "Delete Gateway?",
            text: "Connected agricultural IoT devices may be affected.",
            icon: "warning",
            showCancelButton: true,
            confirmButtonText: "Delete",
            cancelButtonText: "Cancel"
        });
        if (!result.isConfirmed) {
            return;
        }
        try {
            await axios.delete(baseUrl + "iot-gateways/" + id + "/");
            Swal.fire("Deleted", "IoT gateway deleted successfully.", "success");
            fetchGateways();
        } catch (error) {
            console.log("Gateway Delete Error:", error);
            let message = "Unable to delete IoT gateway.";
            if (error.response && error.response.data) {
                if (error.response.data.detail) {
                    message = error.response.data.detail;
                } else {
                    message = JSON.stringify(error.response.data);
                }
            }
            Swal.fire("Error", message, "error");
        }
    };
    // ============================================================
    // COLUMNS
    // ============================================================
    const columns = [{
        field: "id", headerName: "ID", width: 70
    }, {
        field: "gateway_id", headerName: "Gateway ID", width: 160
    }, {
        field: "gateway_name", headerName: "Gateway Name", width: 200
    }, {
        field: "ip_address", headerName: "IP Address", width: 150
    }, {
        field: "port", headerName: "Port", width: 90
    }, {
        field: "farm_code", headerName: "Farm Code", width: 140
    }, {
        field: "location", headerName: "Deployment Location", width: 180
    }, {
        field: "version", headerName: "Version", width: 110
    }, {
        field: "status", headerName: "Status", width: 120, renderCell: (params) => (<span
                className={params.value === "ONLINE" ? "iot-status online" : params.value === "MAINTENANCE" ? "iot-status maintenance" : "iot-status offline"}
            >

                    {params.value || "OFFLINE"}

                </span>)
    }, {
        field: "last_seen", headerName: "Last Seen", width: 190
    }, {
        field: "actions",
        headerName: "Action",
        width: 220,
        sortable: false,
        filterable: false,
        renderCell: (params) => (<div className="iot-action-buttons">


                <button
                    className="btn btn-primary btn-sm"
                    onClick={() => navigate("/iot-gateway-form/" + params.row.id)}
                >

                    Edit

                </button>


                <button
                    className="btn btn-danger btn-sm"
                    onClick={() => deleteGateway(params.row.id)}
                >

                    Delete

                </button>


            </div>)
    }];
    // ============================================================
    // UI
    // ============================================================
    return (<section className="container-fluid mt-4">


            {/* ====================================================
                HEADER
            ==================================================== */}

            <div className="iot-page-header">

                <div>

                    <h3>
                        Agricultural IoT Gateways
                    </h3>

                    <p>
                        Manage gateways connecting agricultural
                        IoT devices to eAgri
                    </p>

                </div>


                <button
                    className="btn btn-success"
                    onClick={() => navigate("/iot-gateway-form/")}
                >

                    + Add Gateway

                </button>

            </div>


            {/* ====================================================
                GATEWAY TABLE
            ==================================================== */}

            <div className="card shadow-sm">

                <div className="card-body">

                    <DataGrid

                        rows={rows}

                        columns={columns}

                        loading={loading}

                        autoHeight

                        disableRowSelectionOnClick

                        pageSizeOptions={[10, 25, 50]}

                        initialState={{
                            pagination: {
                                paginationModel: {
                                    pageSize: 25, page: 0
                                }
                            }
                        }}

                        slots={{
                            toolbar: GridToolbar
                        }}

                        sx={{
                            boxShadow: 3
                        }}

                    />

                </div>

            </div>

        </section>);
}
export default IoTGateways;